import { create } from 'zustand'

const useUIStore = create((set) => ({
  customBack: null,
  setCustomBack: (callback) => set({ customBack: callback }),
}))

export { useUIStore }

